import { Locales } from "@typings/global.types";

import messagesDeDe from "./de_DE.json";
import messagesEnGB from "./en_GB.json";
import messagesEnUs from "./en_US.json";
import messagesEsEs from "./es_ES.json";
import messagesEsMx from "./es_MX.json";
import messagesFrCa from "./fr_CA.json";
import messagesFrFr from "./fr_FR.json";
import messagesItIt from "./it_IT.json";
import messagesNlNl from "./nl_NL.json";
import messagesPlPl from "./pl_PL.json";
import messagesPtBr from "./pt_BR.json";
import messagesRuRu from "./ru_RU.json";
import messagesTrTr from "./tr_TR.json";
import messagesUkUa from "./uk_UA.json";

const messages: Record<`${Locales}`, Record<string, string>> = {
  "de-DE": messagesDeDe,
  "en-US": messagesEnUs,
  "en-GB": messagesEnGB,
  "es-ES": messagesEsEs,
  "es-MX": messagesEsMx,
  "fr-CA": messagesFrCa,
  "fr-FR": messagesFrFr,
  "it-IT": messagesItIt,
  "nl-NL": messagesNlNl,
  "pl-PL": messagesPlPl,
  "pt-BR": messagesPtBr,
  "ru-RU": messagesRuRu,
  "tr-TR": messagesTrTr,
  "uk-UA": messagesUkUa,
};

export default messages;
